export default "__VITE_ASSET__8EcnDX8R__"